import { render } from "./NewDestinationForm.vue?vue&type=template&id=41211af0"
import script from "./NewDestinationForm.vue?vue&type=script&lang=js"
export * from "./NewDestinationForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__